// extracted by mini-css-extract-plugin
export default {"container":"ResultsListItem_container__JoqXe","no-bottom-border-radius":"ResultsListItem_no-bottom-border-radius__E7rN5","details":"ResultsListItem_details__zPOdD"};